import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GlobalSettingsService } from 'src/app/core/gobal-settings.service';
import { getStatusDemande, StatusDemande } from "../../../constants/status";
import { DemandeAgenceService } from 'src/app/shared/services/agence-linked/demande-agence.service';

export interface DialogData {
  icone: string;
  title: string;
  code: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  type: string;
  statut: string;
  result: boolean;
  idAgence: number;
  nivStatus: number;
  bBloquer: boolean;
  fAnnule: boolean;

}
@Component({
  selector: 'app-modal-update-confirmation-agence',
  templateUrl: './modal-update-confirmation-agence.component.html',
  styleUrls: ['./modal-update-confirmation-agence.component.scss']
})
export class ModalUpdateConfirmationAgenceComponent  implements OnInit {
  icone: string;
  title: string;
  message: string;
  color: string;
  iconColor: string;
  dialogWidth: string;
  dialogHeight: string;
  
  canValidateBool = false;
  canEditOrCreateBool = false;
  canReadBool = false;
  canTraitBool = false;
  canCancel = false;

  ValidationStatus: string[] = [,
    getStatusDemande(StatusDemande.AValider)];

  currentRoute: any;
  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              private demandeAgenceService: DemandeAgenceService,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private globalSettingsService: GlobalSettingsService) {
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.iconColor = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.message = this.data.message;
    this.color = this.data.color;

    // - Visualisation demande -> niveau 1 type demande
    // - Création demande -> niveau 2 type demande
    // - Validation demande -> niveau 5 type demande

    this.demandeAgenceService.getAuthorisation().subscribe((res: number[]) => {
      
      if (res.find(d => (d >= 1))) {
        this.canReadBool = true; // Visualisation
      }
      if (res.find(d => d === 2 )) {
        this.canEditOrCreateBool = true; // Création
      }
      if (res.find(d => d === 5 )) {
        this.canValidateBool = true; // Validation
      }
    });
  }

  canEditOrCreate(): boolean {
    return this.canEditOrCreateBool && this.data.statut === getStatusDemande(StatusDemande.Brouillon);
  }


  canValidate(): boolean {
    // 'En attente de validation'
    return this.canValidateBool && (this.data.statut === getStatusDemande(StatusDemande.AValider) || this.data.statut === getStatusDemande(StatusDemande.Validate));
  }

  canRead(): boolean {
    return this.canReadBool;
  }


  onModalCancel(): void {
    this.dialogRef.close(false);
  }

  onModalConfirm(action): void {
    this.data.result = true;
    this.dialogRef.close(action);
  }

  onModalConfirmAnnulation(): void {
    if (this.data.type === 'Agence') 
    {
      this.data.result = true;
      this.dialogRef.close('Annuler');
    } else {
      this.data.result = true;
      this.dialogRef.close(null);
    }
  }

}


